import {Component} from 'react';
import h from 'react-hyperscript';
import {eyebrow} from 'Components/Typography/Typography';

class SurveyElementHeader extends Component {
  render() {
    if (this.props.showRemaining) {
      return (
        h('div', {
          key: 'card-main__header__key',
          className: 'card-main__header flex--space-between',
        }, [
          h(eyebrow, {
            className: 'text--grey text--bold',
          }, `${this.props.answered} out of ${this.props.total} answered`),
          h(eyebrow, {
            className: 'text--grey text--bold',
          }, `${this.props.remaining} incomplete questions`),
        ])
      );
    }

    return (
      h('div', {
        key: 'card-main__header__key',
        className: 'card-main__header flex--space-between',
      }, h(eyebrow, {
        className: 'text--grey text--bold',
      }, `${this.props.answered} out of ${this.props.total} answered`))
    );
  }
}
export default SurveyElementHeader;
